import React, { Component } from 'react';
import { ReactComponent as Back } from '../../../assets/svg/back-icon-new.svg';
import { ReactComponent as Down } from '../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import { ReactComponent as Minus } from '../../../assets/svg/minus-circle.svg';
import { ReactComponent as RegisterIcon } from '../../../assets/svg/hd-reg.svg';
import { ReactComponent as CopyIcon } from '../../../assets/svg/data-copied.svg';
import { ReactComponent as AssignIcon } from '../../../assets/svg/hd-assign.svg';
import { ReactComponent as ReceiveIcon } from '../../../assets/svg/hd-received.svg';
import { ReactComponent as LocationIcon } from '../../../assets/svg/location-update.svg';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { getApolloContext, gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import DataTableCompact from '../../components/DataTableCompact';
import Tree from '../../components/tree';
import { ReactComponent as Search } from '../../../assets/svg/search-img.svg';
import _ from 'lodash';
import Select, { components } from 'react-select';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
const getHddInfo = gql`
	query HddInfo($hddIdentifier: String!) {
		hddInfo(hddIdentifier: $hddIdentifier) {
			qrCode
			manufacturerId
			projectTitle
			projectSlNo
			category
			size
			location
			responsibleUser
			updatedBy
			updatedAt
			tenantId
		}
	}
`;
const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			displayName
		}
	}
`;
const getHddLogs = gql`
	query HddLogs($qrCode: String!) {
		hddLogs(qrCode: $qrCode) {
			notes {
				message
			}
			createdAt
			description {
				assignedTo {
					id
					name
				}
				backupSize
				createdBy {
					id
					name
				}
				mcQrCode
				receivedFrom {
					id
					name
				}
			}
			location
			projectTitle
			qrCode
			status
		}
	}
`;
const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;
class HardDriveLogs extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			hddLogsList: [],
			tenantUserList: [],
			hddInfo: {},
			workspacesFilters: [],
			isHDDLogsListLoading: true,
			isHDDInfoLoading: true,
			isVendorUsersLoading: true,
			isWorkspaceFiltersLoading: true,
		};
	}
	componentDidMount = async () => {
		const json = {
			qrCode: this.props.params.qrCode,
		};
		const json2 = {
			hddIdentifier: this.props.params.qrCode,
		};
		await this.getHddLogs(getHddLogs, json);
		await this.getHddInfo(getHddInfo, json2);
		await this.getTenantUsers(getTenantUserList);
		await this.getVendorsWorkspaces(
			getVendorInfo,
			{
				vendorId: this.props.params.vendorID,
			},
			'modify-object',
		);
	};
	getAssignedToName = (assignedId) => {
		if (this.state.tenantUserList.length !== 0) {
			for (let i = 0; i < this.state.tenantUserList.length; i++) {
				if (this.state.tenantUserList[i].id === assignedId) {
					return (
						this.state.tenantUserList[i].firstName +
						' ' +
						this.state.tenantUserList[i].lastName
					);
				}
			}
		}

		return 'ato name ';
	};
	goBack = (e) => {
		this.props.navigate(-1);
	};
	getWorkspacekey = (name) => {
		if (this.state.workspacesFilters.length !== 0) {
			for (let i = 0; i < this.state.workspacesFilters.length; i++) {
				if (this.state.workspacesFilters[i].workspaceid === name) {
					return this.state.workspacesFilters[i].workspaceKey;
				}
			}
		}
		return ' ';
	};
	render() {
		return (
			<>
				{this.state.isHDDInfoLoading === true ||
				this.state.isHDDLogsListLoading === true ||
				this.state.isVendorUsersLoading === true ||
				this.state.isWorkspaceFiltersLoading === true ? (
					<div className="assign-receive-container ar-harddrive-logs-container">
						<LoadingBar />
					</div>
				) : (
					<div className="assign-receive-container ar-harddrive-logs-container">
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back style={{ width: '20px', height: '20px' }} />
							</div>
							<div className="arch-item">
								<span className="arch-item-span">
									<b className="arch-item-bold">Hard Drive</b>
									<p className="arch-item-p">
										{/* {this.props.params.qrcode} */}
										{this.props.params.qrCode}
									</p>
								</span>
							</div>

							{/* <div className="actn-btn"> */}
							{/* <a onClick={(e) => this.assignHardDriveAPICall()}>Assign Hard Drive</a> */}
							{/* </div> */}
						</div>
						<div className="hd-logs-table-section">
							<div className="hd-logs-table-section-top-div">
								<div className="top-table-conatiner">
									<table className="memoryCardSumaryTable4">
										<tr>
											<th>QR CODE</th>
											<th>PROJECTS</th>
											<th>TYPE</th>
											<th>SIZE</th>
											<th>LOCATION</th>
											<th>ASSIGNED TO</th>
											<th>LAST UPDATED BY</th>
										</tr>
										<tbody>
											{this.state.hddInfo && (
												<tr>
													<td>
														<div className="hd-table-td-qrcode-container">
															<p className="hd-table-td-qrcode-p">
																{this.state.hddInfo.qrCode}
															</p>
															<p className="hd-table-td-qrcode-p2">
																{this.state.hddInfo.manufacturerId}
															</p>
														</div>
													</td>
													<td>
														<div className="hd-table-td-qrcode-container">
															<p className="hd-table-td-qrcode-p">
																{this.state.hddInfo.projectTitle}
															</p>
															<p className="hd-table-td-qrcode-p3">
																{/* this.state.hddInfo.tenantId */}
																{this.getWorkspacekey(
																	this.state.hddInfo.tenantId,
																) +
																	'-' +
																	this.state.hddInfo.projectSlNo}
															</p>
														</div>
													</td>
													<td>
														<span className="completed-shoots">
															<b
																className={
																	'hd-cat-b' +
																	(this.state.hddInfo.category ===
																	'working'
																		? ' workig'
																		: this.state.hddInfo
																				.category ===
																		  'backup'
																		? ' backup'
																		: '')
																}
															></b>
															{this.state.hddInfo.category ===
															'working'
																? 'WORKING'
																: this.state.hddInfo.category ===
																  'backup'
																? 'BACKUP'
																: 'SECURE'}
															{/* <p>{this.props.data.status}</p> */}
														</span>
													</td>
													<td>{this.state.hddInfo.size} TB</td>

													<td>
														{this.state.hddInfo.location &&
															this.state.hddInfo.location
																.charAt(0)
																.toUpperCase() +
																this.state.hddInfo.location
																	.replace(/([A-Z])/g, ' $1')
																	.slice(1)}
														{/* {this.state.hddInfo.location} */}
													</td>
													<td>
														{this.state.hddInfo.location ===
															'inOffice' ||
														this.state.hddInfo.location ===
															'client' ? null : (
															<div className="hd-table-td-qrcode-container">
																<p className="hd-table-td-qrcode-p">
																	{' '}
																	{
																		this.state.hddInfo
																			.responsibleUser &&
																			this.state.hddInfo
																				.responsibleUser
																		// .charAt(0)
																		// .toUpperCase() +
																		// this.state.hddInfo.responsibleUser
																		// 	.replace(
																		// 		/([A-Z])/g,
																		// 		' $1',
																		// )
																		// .slice(1)
																	}
																	{/* {this.state.hddInfo.responsibleUser} */}
																</p>
																<p className="hd-table-td-qrcode-p3">
																	{this.state.hddInfo
																		.responsibleUser
																		? moment
																				.unix(
																					this.state
																						.hddInfo
																						.updatedAt,
																				)
																				.fromNow()
																		: ''}
																</p>
															</div>
														)}
													</td>
													<td>
														<div className="hd-table-td-qrcode-container">
															<p className="hd-table-td-qrcode-p">
																{this.state.tenantUserList.length >
																	0 &&
																	this.getAssignedToName(
																		this.state.hddInfo
																			.updatedBy,
																	)}
															</p>
															<p className="hd-table-td-qrcode-p3">
																{moment
																	.unix(
																		this.state.hddInfo
																			.updatedAt,
																	)
																	.fromNow()}
															</p>
														</div>
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>

							<div className="hdLogsSecondPart">
								<div className="hdLogsSecondPart-div1">
									<p className="hdLogsSecondPart-div1-p">LIST OF SCANS</p>
									<table className="memoryCardSumaryTable4">
										<tr>
											<th>DATE & TIME</th>
											<th>NO. OF FILES</th>
											<th>DATA SIZE</th>
											<th>NO. OF FOLDERS</th>
										</tr>
									</table>
								</div>
								<div className="hdLogsSecondPart-div2">
									<p className="hdLogsSecondPart-div2-p">HD LOGS</p>
									<table className="memoryCardSumaryTable4">
										<tr>
											<th>DATE & TIME</th>
											<th></th>
											<th>TYPE</th>
											<th>DESCRIPTION</th>
											<th>NOTES</th>
										</tr>
										<tbody>
											{this.state.hddLogsList.length !== 0 &&
												_.reverse(
													this.state.hddLogsList.map((el, idx) => {
														return (
															<tr className="hdLogs-row">
																<td>
																	{moment
																		.unix(el.createdAt)
																		.format(
																			'DD MMM YYYY, HH:MM a',
																		)}
																</td>
																<td>
																	{idx === 0 ? (
																		<RegisterIcon />
																	) : el.status === 'busy' ? (
																		<AssignIcon />
																	) : el.status === 'ready' ? (
																		<ReceiveIcon />
																	) : el.status === 'backup' ? (
																		<CopyIcon />
																	) : (
																		<LocationIcon />
																	)}
																</td>
																<td>
																	{idx === 0
																		? 'HD Registered'
																		: el.status === 'busy'
																		? 'HD assigned'
																		: el.status === 'ready'
																		? 'HD recieved'
																		: el.status === 'backup'
																		? 'Data Copied'
																		: 'Location Update'}
																</td>
																<td>
																	{idx === 0
																		? `Registered to ${el.projectTitle} by ${el.description.createdBy.name}`
																		: el.status === 'busy'
																		? `Assigned to ${
																				_.has(
																					el.description
																						.assignedTo,
																					'name',
																				)
																					? el.description
																							.assignedTo
																							.name
																					: '-'
																		  } by ${
																				el.description
																					.createdBy.name
																		  }`
																		: //   `Assigned to by ${el.description.createdBy.name}`
																		el.status === 'ready'
																		? `Received ${
																				el.description
																					?.receivedFrom
																					?.name
																					? ' from ' +
																					  el.description
																							.receivedFrom
																							.name
																					: ''
																		  } by ${
																				el.description
																					.createdBy.name
																		  }`
																		: el.status === 'backup'
																		? `${el.description.backupSize} GB copied from ${el.description.mcQrCode} by ${el.description.createdBy.name}`
																		: `Location updated to Client by `}
																</td>
																<td>
																	{el.notes
																		? el.notes.message
																		: ''}
																</td>
															</tr>
														);
													}),
												)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}
export default withRouter(HardDriveLogs);
